// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MilestoneCatalogPageMetaDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MilestoneCatalogPageMetaDataQuery = { __typename?: 'Query', globalPlanMilestoneGroups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }> };

export type MilestoneCatalogPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalPlanMilestoneFilter>;
  orderBy?: Types.InputMaybe<Types.GlobalPlanMilestoneOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type MilestoneCatalogPageQuery = { __typename?: 'Query', globalPlanMilestones: { __typename?: 'GlobalPlanMilestonesPageResult', entities: Array<{ __typename?: 'GlobalPlanMilestone', id: string, name: string, isDefault: boolean, systemPlanMilestone?: { __typename?: 'SystemPlanMilestoneDetail', code: Types.SystemPlanMilestone, name: string } | null | undefined, groups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type MilestoneCatalogPage_GlobalPlanMilestoneFragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string, isDefault: boolean, systemPlanMilestone?: { __typename?: 'SystemPlanMilestoneDetail', code: Types.SystemPlanMilestone, name: string } | null | undefined, groups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }> };

export type MilestoneCatalogPage_GlobalPlanMilestoneGroupFragment = { __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } };

export const MilestoneCatalogPage_GlobalPlanMilestoneGroupFragmentDoc = gql`
    fragment MilestoneCatalogPage_GlobalPlanMilestoneGroup on GlobalPlanMilestoneGroup {
  id
  name
  businessFunctionType {
    code
    name
  }
}
    `;
export const MilestoneCatalogPage_GlobalPlanMilestoneFragmentDoc = gql`
    fragment MilestoneCatalogPage_GlobalPlanMilestone on GlobalPlanMilestone {
  id
  name
  isDefault
  systemPlanMilestone {
    code
    name
  }
  groups {
    ...MilestoneCatalogPage_GlobalPlanMilestoneGroup
  }
  constraints {
    id
  }
}
    ${MilestoneCatalogPage_GlobalPlanMilestoneGroupFragmentDoc}`;
export const MilestoneCatalogPageMetaDataDocument = gql`
    query MilestoneCatalogPageMetaData {
  globalPlanMilestoneGroups {
    ...MilestoneCatalogPage_GlobalPlanMilestoneGroup
  }
}
    ${MilestoneCatalogPage_GlobalPlanMilestoneGroupFragmentDoc}`;

/**
 * __useMilestoneCatalogPageMetaDataQuery__
 *
 * To run a query within a React component, call `useMilestoneCatalogPageMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneCatalogPageMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneCatalogPageMetaDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMilestoneCatalogPageMetaDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>(MilestoneCatalogPageMetaDataDocument, options);
      }
export function useMilestoneCatalogPageMetaDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>(MilestoneCatalogPageMetaDataDocument, options);
        }
export function useMilestoneCatalogPageMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>(MilestoneCatalogPageMetaDataDocument, options);
        }
export type MilestoneCatalogPageMetaDataQueryHookResult = ReturnType<typeof useMilestoneCatalogPageMetaDataQuery>;
export type MilestoneCatalogPageMetaDataLazyQueryHookResult = ReturnType<typeof useMilestoneCatalogPageMetaDataLazyQuery>;
export type MilestoneCatalogPageMetaDataSuspenseQueryHookResult = ReturnType<typeof useMilestoneCatalogPageMetaDataSuspenseQuery>;
export type MilestoneCatalogPageMetaDataQueryResult = Apollo.QueryResult<MilestoneCatalogPageMetaDataQuery, MilestoneCatalogPageMetaDataQueryVariables>;
export const MilestoneCatalogPageDocument = gql`
    query MilestoneCatalogPage($filter: GlobalPlanMilestoneFilter, $orderBy: GlobalPlanMilestoneOrder, $page: PageFilter) {
  globalPlanMilestones(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...MilestoneCatalogPage_GlobalPlanMilestone
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${MilestoneCatalogPage_GlobalPlanMilestoneFragmentDoc}`;

/**
 * __useMilestoneCatalogPageQuery__
 *
 * To run a query within a React component, call `useMilestoneCatalogPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneCatalogPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneCatalogPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMilestoneCatalogPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>(MilestoneCatalogPageDocument, options);
      }
export function useMilestoneCatalogPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>(MilestoneCatalogPageDocument, options);
        }
export function useMilestoneCatalogPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>(MilestoneCatalogPageDocument, options);
        }
export type MilestoneCatalogPageQueryHookResult = ReturnType<typeof useMilestoneCatalogPageQuery>;
export type MilestoneCatalogPageLazyQueryHookResult = ReturnType<typeof useMilestoneCatalogPageLazyQuery>;
export type MilestoneCatalogPageSuspenseQueryHookResult = ReturnType<typeof useMilestoneCatalogPageSuspenseQuery>;
export type MilestoneCatalogPageQueryResult = Apollo.QueryResult<MilestoneCatalogPageQuery, MilestoneCatalogPageQueryVariables>;